module.exports = __webpack_public_path__ + "img/Brojure.d71d23d1.svg";